import React, { useEffect, useState } from "react";
import HeadCont from "../components/common/HeadCont";
import CalendarHeader from "../components/common/CalendarHeader";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "../components/common/Dialog";
import {
  deleteOneTreatment,
  editOneTreatment,
  fetchExistTreatmentDataOfYear,
  fetchOneTreatment,
  fetchTreatment,
  saveTreatment,
} from "../../../features/mobile/treatmentSlice";
import Btn from "../components/common/Btn";
import { AnimatePresence, motion } from "framer-motion";
import { saveChosenDate } from "../../../features/mobile/commonSlice";
import { ToastContainer, toast } from "react-toastify";
import toastCommonProps from "../../../common/toast";
import { useTranslation } from "react-i18next";
import CustomTimePicker from "../../../components/CustomTimePicker";

const Treatment = () => {
  const { t } = useTranslation('health');
  dayjs.locale("en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dropdown, setDropdown] = useState(false);

  const [status, setStatus] = useState({ status: "show", id: null }); // show: display, add: input, edit: edit
  const [openDialog, setOpenDialog] = useState(false);
  const [startDate, setStartDate] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );
  const [value, setValue] = useState({
    hospital: "",
    time: "",
    alarm: 0,
    memo: "",
  });

  const alarmList = [
    { title: t("treatment.same_day_9am"), value: 0 },
    { title: t("treatment.one_day_before_9am"), value: 1 },
    { title: t("treatment.two_days_before_9am"), value: 2 },
    { title: t("treatment.no_reminder"), value: -1 },
  ];

  const { loginInfo, chosenDate } = useSelector((state) => state.commonApp);
  const { treatmentList, existDaysOfYear } = useSelector(
    (state) => state.treatment
  );

  const onSaveOrEditTreatment = async () => {
    console.log("dflakjsd");
    let userId = loginInfo.userId;
    let params = {
      name: value.hospital,
      date: chosenDate || startDate,
      hour: Number(value.time.split(":")[0]),
      minute: Number(value.time.split(":")[1]),
      alarm: value.alarm,
      memo: value.memo,
    };
    if (value.hospital.length <= 0) {
      toast(
        <p>{t("treatment.enter_hospital_name")}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
      return;
    }
    if (status.status === "add") {
      dispatch(saveTreatment({ ...params, userId }))
        .unwrap()
        .then((res) => {
          if (res.ok) {
            dispatch(
              fetchExistTreatmentDataOfYear({
                userId: loginInfo.userId,
                year: Number(dayjs(startDate).format("YYYY")),
              })
            );
            setStatus({ status: "show", id: null });
          }
        })
        .catch((err) => console.log(err));
    } else if (status.status === "edit") {
      dispatch(editOneTreatment({ ...params, id: status.id }))
        .unwrap()
        .then((res) => {
          if (res.ok) {
            setStatus({ status: "show", id: null });
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const onDeleteTreatment = () => {
    dispatch(deleteOneTreatment(status.id))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          dispatch(
            fetchExistTreatmentDataOfYear({
              userId: loginInfo.userId,
              year: Number(dayjs(startDate).format("YYYY")),
            })
          );
          setOpenDialog(false);
          setStatus({ status: "show", id: null });
        }
      });
  };

  useEffect(() => {
    dispatch(
      fetchTreatment({
        userId: loginInfo.userId,
        date: chosenDate || startDate,
      })
    );
  }, [chosenDate, status]);

  useEffect(() => {
    // When the visible calendar range (startDate) or selected date year changes
    let params = {
      userId: loginInfo.userId,
      year: Number(dayjs(startDate).format("YYYY")),
    };
    dispatch(fetchExistTreatmentDataOfYear(params));
  }, [dayjs(startDate).format("YYYY")]);

  return (
    <>
      {status.status === "show" ? (
        <>
          <HeadCont
            title={t("treatment.appointment_reminder")}
            transparent={"white"}
            onLeftAction={() => navigate(-1)}
            onRightAction={() => navigate("/home")}
            rightIcon={"home"}
          />

          <CalendarHeader
            type={"APPOINTMENT_REMINDER"}
            startDate={startDate}
            setStartDate={setStartDate}
            chosenDate={chosenDate}
            // setChosenDate={setChosenDate}
            existDaysOfYear={[...existDaysOfYear]}
          />
          <div className="-mt-[28px] rounded-tl-[28px] bg-white p-6">
            <div className="pb-[80px] pt-[10px]">
              {treatmentList.length === 0 ? (
                <p className="text-xl font-bold text-[#05040D]">
                  {t("treatment.add_appointment_reminder")}
                </p>
              ) : (
                <ul className="flex flex-col gap-[10px]">
                  {treatmentList.map(
                    ({ id, name, date, hour, minute, alarm, memo }) => {
                      return (
                        <li
                          key={id}
                          className="flex justify-between rounded-[10px] border border-[#B4EBFF] bg-[#E8F6FB] px-5 py-[10px]"
                          onClick={() => {
                            setValue({
                              hospital: name,
                              date,
                              time: `${hour}:${String(minute).padStart(
                                2,
                                "0"
                              )}`,
                              alarm: alarm || 0,
                              memo,
                            });
                            setStatus({ status: "edit", id: id });
                          }}
                        >
                          <div className="flex flex-col justify-center gap-3">
                            <div className="flex h-10 items-center">
                              <span className="line-clamp-2 w-52 text-ellipsis whitespace-normal text-[18px] font-semibold leading-[20px] text-[#0D0D0D]">
                                {name}
                              </span>
                            </div>
                            <div className="flex items-center gap-[6px] text-[#454545]">
                              <p>{date}</p>
                              <p className="h-[8px] w-[2px] bg-[#DBDFE0]"></p>
                              <p>
                                {hour > 12
                                  ? `${t("treatment.pm")} ${hour - 12}`
                                  : `${t("treatment.am")} ${hour}`}{" "}
                                : {String(minute).padStart(2, "0")}
                              </p>
                            </div>
                            {memo && (
                              <div className="text-sm text-[#6B7280] line-clamp-2">
                                {memo}
                              </div>
                            )}
                          </div>
                          <img
                            src="/images/mobile/icon/chevron_skyblue.svg"
                            alt={t("treatment.edit_alt")}
                          />
                        </li>
                      );
                    }
                  )}
                </ul>
              )}
              <button
                onClick={() => {
                  setValue({
                    hospital: "",
                    memo: "",
                    alarm: 0,
                    time: dayjs(new Date()).format("HH:mm"),
                  });
                  setStatus({ status: "add", id: null });
                }}
                className="fixed bottom-4 left-6 right-6 rounded-2xl bg-[#3A404D] p-4 text-body3_700 text-white"
              >
                {t("treatment.add_reminder")}
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <HeadCont
            title={t("treatment.setup_reminder")}
            transparent={"white"}
            underline={true}
            onLeftAction={() => setStatus({ status: "show", id: null })}
          />

          <div className="mt-14 flex flex-col gap-2 p-5 text-base font-bold text-[#444444]">
            <label className="my-[10px]">
              {t("treatment.hospital_name")}
              <input
                name="hospital"
                type="text"
                value={value.hospital}
                placeholder={t("treatment.hospital_name_placeholder")}
                className="my-[10px] w-full rounded-md border border-[#DFDFDF] p-[10px] font-semibold text-[#545454] focus:outline-none focus:ring-0"
                onChange={(e) =>
                  setValue({ ...value, hospital: e.currentTarget.value })
                }
              />
              {}
            </label>
            <p>{t("treatment.scheduled_time")}</p>
            <div className="my-[10px] flex gap-[10px]">
              <label className="flex w-1/2 flex-col">
                {t("treatment.date")}
                <input
                  name="date"
                  type="date"
                  lang="en"
                  value={chosenDate || startDate}
                  pattern="\d{4}-\d{2}-\d{2}"
                  className="my-[10px] w-full appearance-none rounded-md border border-[#DFDFDF] bg-white p-[10px] font-semibold text-[#545454] focus:outline-none focus:ring-0"
                  onChange={(e) =>
                    dispatch(saveChosenDate(e.currentTarget.value))
                  }
                />
              </label>
              <label className="flex w-1/2 flex-col">
                {t("treatment.time")}
                <CustomTimePicker
                  name="time"
                  value={value.time}
                  className="my-[10px] w-full"
                  onChange={(e) =>
                    setValue({ ...value, time: e.target.value })
                  }
                />
              </label>
            </div>

            <p>{t("treatment.reminder_time")}</p>
            <div className="relative shrink-0">
              <button
                type="button"
                className="flex w-full items-center justify-center rounded-md border border-[#DFDFDF] bg-white p-[10px] font-semibold text-[#545454]"
                id="menu-button"
                onClick={() => {
                  setDropdown(!dropdown);
                }}
              >
                {
                  alarmList.filter((list) => list.value === value.alarm)[0]
                    ?.title
                }
              </button>
              <AnimatePresence>
                {dropdown ? (
                  <motion.div
                    initial={{ scaleY: 0 }}
                    animate={{
                      scaleY: 1,
                      transition: { ease: "easeIn", duration: 0.1 },
                    }}
                    exit={{
                      scale: 0,
                      transition: { type: "spring", bounce: 0, duration: 0.2 },
                    }}
                    style={{ originY: 0 }}
                    className="-shadow-basic absolute top-12 z-20 w-full overflow-hidden rounded-2xl"
                  >
                    <ul className="-shadow-basic flex h-fit w-full flex-col items-center overflow-hidden border bg-[#E8F6FB] font-bold">
                      {alarmList.map((list) => (
                        <li
                          key={list.title}
                          onClick={() => {
                            setValue({ ...value, alarm: list.value });
                            setDropdown(false);
                          }}
                          className="flex w-full justify-center overflow-hidden py-3 "
                        >
                          <button>{list.title}</button>
                        </li>
                      ))}
                    </ul>
                  </motion.div>
                ) : null}
              </AnimatePresence>
            </div>

            <label className="my-[10px]">
              {t("treatment.add_memo")}
              <textarea
                name="memo"
                className="my-[10px] h-52 w-full rounded-md border border-[#DFDFDF] p-[10px] font-semibold text-[#545454] focus:outline-none focus:ring-0"
                placeholder={t("treatment.memo_placeholder")}
                value={value.memo}
                onChange={(e) =>
                  setValue({ ...value, memo: e.currentTarget.value })
                }
              />
            </label>
          </div>

          <div className="fixed bottom-4 left-6 right-6 flex gap-[10px] text-body3_700">
            {status.status === "edit" ? (
              <>
                <Btn
                  title={t("treatment.delete")}
                  innerClass="w-2/5 rounded-2xl"
                  textColor="text-[#3A404D]"
                  borderColor="border border-[#3A404D]"
                  bgColor="bg-white"
                  active={"on"}
                  onAction={() => setOpenDialog(true)}
                />

                <button
                  className={`w-3/5 rounded-2xl py-4 text-white ${
                    value.hospital.length > 0 && value.time !== null
                      ? "bg-[#3A404D]"
                      : "bg-[#939393] text-white"
                  }`}
                  onClick={onSaveOrEditTreatment}
                >
                  {t("treatment.update_complete")}
                </button>
              </>
            ) : (
              <button
                className={`z-30 w-full rounded-2xl py-4 text-white ${
                  value.hospital.length > 0 && value.time !== null
                    ? "bg-[#3A404D]"
                    : "bg-[#939393] text-white"
                }`}
                onClick={onSaveOrEditTreatment}
              >
                {t("treatment.add")}
              </button>
            )}
          </div>

          {openDialog && (
            <Dialog
              innerClass={"p-4"}
              title={t("treatment.delete_reminder")}
              desc={t("treatment.delete_reminder_confirm")}
              leftBtnTitle={t("treatment.yes_delete")}
              rightBtnTitle={t("treatment.no_cancel")}
              onLeftBtnAction={onDeleteTreatment}
              onRightBtnAction={() => setOpenDialog(false)}
              onCoverAction={() => setOpenDialog(false)}
            />
          )}
        </>
      )}
      <ToastContainer />
    </>
  );
};

export default Treatment;
